import { ErrorState } from '@/components/ui/ErrorState'
import { LoadingState } from '@/components/ui/LoadingState'
import { PageHeader } from '@/components/ui/PageHeader'
import { SettlementDeductionListTable } from '@/components/venue/SettlementDeductionListTable'
import { useVenueSettlementDeductions } from '@/hooks/useVenueSettlementDeductions'
import { defaultDeductionsFilter } from '@/lib/venue/settlementViewModel'
import { useVenueContext } from '@/routes/venueContext'

/**
 * 분쟁환불 차감 내역 — 'sales/deductions'(설계 §2). 다음 정산 회차 기준 차감 건수·총액·차감 후 예정 금액.
 * 🚨 서버 기본값(다음 정산 회차)만 보여준다 — 요구사항이 회차 선택 UI를 요구하지 않아 만들지 않았다(YAGNI).
 */
export function VenueSalesDeductionsPage() {
  const { venueId } = useVenueContext()

  const deductionsQuery = useVenueSettlementDeductions(venueId, defaultDeductionsFilter())

  const pages = deductionsQuery.data?.pages ?? []
  const lastPage = pages.at(-1)
  const deductions = pages.flatMap((page) => page.deductions)

  return (
    <>
      <PageHeader title="분쟁환불 차감 내역" description="다음 정산에서 차감되는 내역을 확인합니다." />

      {deductionsQuery.isLoading ? <LoadingState rows={4} label="차감 내역을 불러오는 중" /> : null}

      {deductionsQuery.isError ? (
        <ErrorState
          error={deductionsQuery.error}
          onRetry={() => {
            void deductionsQuery.refetch()
          }}
        />
      ) : null}

      {lastPage ? (
        <SettlementDeductionListTable
          data={{ ...lastPage, deductions }}
          hasNextPage={deductionsQuery.hasNextPage ?? false}
          isFetchingNextPage={deductionsQuery.isFetchingNextPage}
          onLoadMore={() => {
            void deductionsQuery.fetchNextPage()
          }}
        />
      ) : null}
    </>
  )
}
